
async function trigger_journey(email, journey_slug) {
    const CSRF_TOKEN = document.getElementsByName('csrfmiddlewaretoken')[0].value;

    // POST email to the backend
    const request = await fetch('/ajax/trigger-journey/', {
      method: 'POST',
      headers: {
        'X-CSRFToken': CSRF_TOKEN,
      },
      body: JSON.stringify({ email, journey_slug }),
    });

    const data = await request.json();

    return data;
}

export { trigger_journey };